import { log } from 'utils/error-logging';
import intelligentShoppingExperience from 'api/definitions/intelligent-shopping-experience';
import type { ApiCallResponse } from 'api/types';
import type { Eligibility } from 'api/definitions/intelligent-shopping-experience/types';
import { GET_SHOP_BY_LIST_ELIGIBILITY } from './types';

export const getShopByListEligibility =
  (): WtrThunkAction<Promise<void | ApiCallResponse<Eligibility>>> => dispatch =>
    dispatch({
      types: GET_SHOP_BY_LIST_ELIGIBILITY.triplet,
      apiCall: intelligentShoppingExperience.getEligibility({
        iHandleStatusCodes: true,
      }),
    }).catch(error => {
      log(error, { logger: 'intelligent-shopping-experience', section: 'shop-by-list' });
    }) as Promise<void | ApiCallResponse<Eligibility>>;
